import { s, typographyTokens } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

export const projectIdentityGap = s('md');

export const projectIdentityRootSx = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: projectIdentityGap,
  minWidth: 0,
  maxWidth: '100%',
} as const;

export const projectIdentityBadgeSlotSx = {
  display: 'inline-flex',
  flexShrink: 0,
} as const;

export const projectIdentityFallbackIconSlotSx = {
  width: 20,
  height: 20,
  borderRadius: s('xs'),
  backgroundColor: 'transparent',
  color: 'inherit',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
} as const;

export const projectIdentityTextFrameSx = {
  minWidth: 0,
  overflow: 'hidden',
  display: 'flex',
  flexDirection: 'column',
} as const;

export const projectIdentityPrimaryTextSx = {
  display: 'block',
  fontSize: '14px !important',
  fontWeight: typographyTokens.overline.fontWeight,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
} as const;

export const projectIdentitySecondaryTextSx: SxProps<Theme> = {
  display: 'block',
  fontSize: (theme: Theme) => theme.typography.caption.fontSize,
  fontWeight: typographyTokens.body.fontWeight,
};
